import PixiTop from "./top/pixitop.es6";

const pixiTop = new PixiTop();
